export type { Locations } from "./LocationsGrid";
export { default } from "./LocationsGrid";
